import { AnalyticsDataLayer } from './../../services/analytics/definitions/analytics.interface';
import { Injectable } from '@angular/core';
import { BehaviorSubject, concatMap, Observable, tap } from 'rxjs';
import { NotificationFactory } from './notification.factory';
import { BulkreadInput, DeletePayload, NotificationList, NotificationState, NotificationTab, ResponseData, ResponseNotification, SingleNotification, UnreadCountData, UpdateNotificationList } from './definitions';
import { ApiResponse } from '../../definitions/api-response.interface';
import { ApiService } from '../../services/api/api.service';
import { LoggerService } from '../../services/logger/logger.service';
import { SharedService } from '../../services/shared/shared.service';
import { AnalyticsService } from '../../services/analytics/analytics.service';
import { SharedApiService } from '../../services/shared/shared-api-call.service';
import { LoggedInUser } from '../../services/shared/shared-interface';
import { LanguageCode, Notifications } from '../../services/shared/shared-enums';
import { indexOf } from 'lodash';
@Injectable({
	providedIn: 'root'
})
export class NotificationService
{
	constructor( public apiService: ApiService, public loggerService: LoggerService, private readonly sharedService: SharedService, private readonly sharedApiService: SharedApiService, private readonly analyticsService: AnalyticsService) { }
	notificationOrignalData : ResponseNotification[] = [];
	notificationOrignalDataUpdate : ResponseNotification[] = [];
	notificationOrignalDataAction : ResponseNotification[] = [];
	notificationOrignalDataOffer :ResponseNotification[] = [];
	notificationCount: UnreadCountData = { all: 0, offer: 0, action: 0, update: 0 };
	currentPage: number = 0;
	totalPages: number = 1;
	selectedIndex: number = 0;
	deletePayload: DeletePayload = {
		portalUserID: '',
    	contactGRID: '',
    	status: 'archived',
    	notifications: [{
			messageID: '',
			customerGRID: '',
			notificationType: ''
		}]
	};
	updatePayload: DeletePayload = {
		portalUserID: '',
    	status: 'read',
		contactGRID: '',
    	notifications: [{
			messageID: '',
			customerGRID: '',
			notificationType: ''
		}]
	};
	updateNotificationList: BulkreadInput ={
		id: '',
		notificationType: ''
	};
	bulkInput: UpdateNotificationList ={
		bulkReadInput: []
	};
	private readonly state$: BehaviorSubject<NotificationState> = new BehaviorSubject<NotificationState>(
		NotificationFactory.build()
	);
	get state(): NotificationState
	{
		return this.state$.value;
	}
	private readonly updateCurrentPage$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
		false
	);
	get updateCurrentPage(): boolean
	{
		return this.updateCurrentPage$.value;
	}
	get updateCurrentPageChanged(): Observable<boolean>
	{
		return this.updateCurrentPage$.asObservable();
	}
	public updateCurrentPageState(value: boolean): void
	{
		this.updateCurrentPage$.next(value);
	}
	get stateChanged(): Observable<NotificationState>
	{
		return this.state$.asObservable();
	}
	public pushAnalyticsEvent(data: AnalyticsDataLayer): void
	{
		this.analyticsService.trackByEvent(data);
	}
	public updateState(value: NotificationState): void
	{
		this.state$.next(value);
	}
	public getNotificationLabels()
	{
		this.apiService.getNotificationsAemLabels().subscribe({
			next: (res) =>
			{
				if (res)
				{
					this.state.pageHeading = res.pageHeading;
					this.state.tabs[0].label = res.tabs[0].label;
					this.state.tabs[1].label = res.tabs[1].label;
					this.state.tabs[2].label = res.tabs[2].label;
					this.state.tabs[3].label = res.tabs[3].label;
					this.state.markAsRead = res.markAsRead;
					this.state.noNotification = res.noNotification;
					this.state.clickHere = res.clickHere;
				}
			}
		});
	}
	public getNotificationData(notification:NotificationList)
	{
		this.state.loading = true;
		this.sharedService.getLoggedInUserObs().pipe(tap((userData: LoggedInUser) =>
		{
			notification.portalUserID = userData.userId;
			notification.contactGRID = userData.contactGRID? userData.contactGRID : userData.contactID;
			notification.roles = userData.roles;			
		}),
		concatMap(() => this.sharedService.getLoggedInUseLocationsIdsObs()),
		tap((locationIds: string[]) => 
		{
			notification.locations = locationIds;
		}),
		concatMap(() => this.apiService.notificationList(notification))).subscribe({
			next: (res: ApiResponse) =>
			{
				if (res?.data)
				{
					const responseObject: ResponseData = <ResponseData>res.data;
					const responseObjectData: ResponseNotification[] = responseObject.notificationData;
					this.notificationCount = responseObject.unreadCountData? responseObject.unreadCountData : { all: 0, offer: 0, action: 0, update: 0 };
				        this.notificationOrignalData =  responseObjectData || [];
					this.state.tabs.forEach((key:NotificationTab) =>
					{
						key.data = responseObjectData || [];
							
					});
					this.state.tabs[0].data.forEach((value) =>
					{
						value.dateCreated =  (new Intl.DateTimeFormat(LanguageCode.default, { month: 'long', day: 'numeric' }).format(new Date()));
						if(value.hasReport)
						{
							const remainingText = value.notificationDescription?.substring(value.notificationDescription.indexOf(this.state.clickHere) + this.state.clickHere.length);
							value.notificationDescription = remainingText;
						}
					});

					this.notificationOrignalDataUpdate = this.filterArray(Notifications.update.toLocaleLowerCase());
					this.notificationOrignalDataOffer= this.filterArray(Notifications.offer.toLocaleLowerCase());
					this.notificationOrignalDataAction=this.filterArray(Notifications.action.toLocaleLowerCase());

					const bulkInput:UpdateNotificationList= { bulkReadInput: [] };
					responseObjectData?.forEach((el: ResponseNotification) =>
					{
						if(el.status === 'unread')
						{
							const arrayInputs={
								id: el.id,
								notificationType: el.notificationType
							};
							bulkInput.bulkReadInput.push(arrayInputs);
						}
					});
					this.unreadCountForfirstPage(bulkInput) ;
				}
			},
			error: ()=>
			{
				this.state.tabs.forEach((key:NotificationTab) =>
				{
					key.data = [];
					key.pageInfo.totalCount= 0;
					key.unreadCountData= 0;
					key.id= '';

				});
				this.state.loading = false;
			},
			complete: () =>
			{
				setTimeout(() =>
				{
					this.state.loading = false;
					this.updateCurrentPageState(true);
				}, 1000);
			}
		});
	}
	checkIfNotificationsPresent(responseObject: NotificationTab)
	{
		if( responseObject.data.length === 0)
		{
			this.updateCurrentPage$.next(true);
		}
	}
	checkForUnreadNotifications(bulkInput: UpdateNotificationList)
	{
		bulkInput.bulkReadInput.length > 0? this.updateNotificationData(bulkInput) : this.sharedApiService.getUnreadNotificationsCount();
	}
	unreadCountForfirstPage(bulkInput: UpdateNotificationList)
	{
		this.state.unreadCount = bulkInput.bulkReadInput.length > 0 ? this.state.tabs[0].unreadCountData-bulkInput.bulkReadInput.length: this.state.tabs[0].unreadCountData;
	}
	public deleteNotification(id: string)
	{
		this.state.loading = true;
		this.deletePayload.notifications[0].messageID = id;
		this.notificationOrignalData?.forEach((val: ResponseNotification) =>
		{
			if(val.id === id)
			{
				this.deletePayload.notifications[0].notificationType = val.notificationType;				
			}
		});
		this.deletePayload.notifications[0].customerGRID= '';
		this.deletePayload.status = Notifications.archived;
		this.sharedService.getLoggedInUserObs().pipe(tap((userData: LoggedInUser) =>
		{
			this.deletePayload.portalUserID = userData.userId;
			this.deletePayload.contactGRID = userData.contactGRID? userData.contactGRID : '';
		}),
		concatMap(() => this.apiService.removeNotification(this.deletePayload))).subscribe({
			next: (res: ApiResponse) =>
			{
				this.loggerService.log(JSON.stringify(res));
				if(res?.success)
				{
					this.getUpdatedNotificationData(id);
				}
			},
			complete: () =>
			{
				setTimeout(() =>
				{
					this.state.loading = false;
				}, 1000);
			} 
		});
	}
	checkUnreadNotifications(notificationData: ResponseNotification[]) 
	{
		return notificationData.filter(t => t.status !== 'read').length;
	}
	public updateNotification(notificationData: ResponseNotification[], markAllread: boolean = false)
	{
		if (markAllread === true)
		{
			this.state.loading = true;
		}
		this.updatePayload.status = Notifications.read;
		this.updatePayload.notifications=[];
		notificationData.forEach(ele => 
		{
			const readNotification:SingleNotification = { messageID: '', customerGRID: '', notificationType: '' };
			readNotification.messageID = ele.id;
			readNotification.customerGRID = ele.customerGRID? ele.customerGRID : '';
			readNotification.notificationType = ele.notificationType;
			this.updatePayload.notifications.push(readNotification);
		});
		this.sharedService.getLoggedInUserObs().pipe(tap((userData: LoggedInUser) => 
		{
			this.updatePayload.portalUserID = userData.userId;
			this.updatePayload.contactGRID = userData.contactGRID? userData.contactGRID : '';
		}),
		concatMap(() => this.apiService.removeNotification(this.updatePayload))).subscribe({
			next: (res: ApiResponse) => 
			{
				this.state.loading = false;
				this.loggerService.log(JSON.stringify(res));
				if (markAllread === true)
				{
					this.sharedApiService.updatedUnreadNotificationState = false;
					this.notificationOrignalData.forEach(data => data.status = Notifications.read);
					this.state.tabs[1].unreadCountData = this.checkUnreadNotifications(this.notificationOrignalDataUpdate);
					this.state.tabs[2].unreadCountData = this.checkUnreadNotifications(this.notificationOrignalDataAction);
					this.state.tabs[3].unreadCountData = this.checkUnreadNotifications(this.notificationOrignalDataOffer);
					this.state.tabs[0].unreadCountData = this.checkUnreadNotifications(this.notificationOrignalData);
				}
			}
		});
	}
	getUpdatedNotificationData(id: string)
	{
		const messageId = this.deletePayload.notifications[0].messageID;
		this.notificationOrignalData?.forEach((val) =>
		{
			if(val.id === id)
			{
				this.updateNotificationListAfterDelete(this.notificationOrignalData, val, 0);
			}
		});
		this.notificationOrignalDataUpdate?.forEach((val) =>
		{
			if(val.id === messageId && val.notificationType === Notifications.update.toLocaleLowerCase())
			{
				this.updateNotificationListAfterDelete(this.notificationOrignalDataUpdate, val, 1);
			}
		});
		this.notificationOrignalDataAction?.forEach((val) =>
		{
			if(val.id === messageId && val.notificationType === Notifications.action.toLocaleLowerCase())
			{
				this.updateNotificationListAfterDelete(this.notificationOrignalDataAction, val, 2);
			}
		});
		this.notificationOrignalDataOffer?.forEach((val) =>
		{
			if(val.id === messageId && val.notificationType === Notifications.offer.toLocaleLowerCase())
			{
				this.updateNotificationListAfterDelete(this.notificationOrignalDataOffer, val, 3);
			}
		});
	}
	public updateNotificationData(updateNotificationList:UpdateNotificationList)
	{
		this.apiService.updateNotificationList(updateNotificationList).pipe(tap()).subscribe({
			next: (res: ApiResponse) =>
			{
				const response = res;
				this.loggerService.log('updated request' + response);
				this.sharedApiService.getUnreadNotificationsCount();
			}
		});
	}
	filterArray( tabName : string)
	{
		const filteredArray = this.notificationOrignalData.filter(function(itm)
		{
			return tabName.indexOf(itm.notificationType) > -1;
		});
	   return filteredArray;
	}
	updateNotificationListAfterDelete(notificationData: ResponseNotification[], val: ResponseNotification, tabIndex: number)
	{
		const index = indexOf(notificationData, val);
		notificationData.splice(index, 1);
		this.state.tabs[this.selectedIndex].data = notificationData;
		if((Math.ceil(notificationData.length / 7)< this.totalPages && this.currentPage> 0 && this.currentPage === this.totalPages) && this.selectedIndex === tabIndex)
		{
			this.updateCurrentPage$.next(true);
		}
		this.state.tabs[this.selectedIndex].unreadCountData = notificationData.filter(t=>t.status !== 'read').length;
	}
	downloadReport(data: string | undefined)
	{
		this.state.loading = true;
		const queryParams = data ?? '';
		this.apiService.downloadNotificationReport(queryParams).subscribe({
			next: (response) =>
			{
				this.state.loading = false;

				this.sharedService.downloadExcel(queryParams, response);
			},
			error: (err) =>
			{
				this.state.loading = false;
				this.loggerService.error('Error in downloading report: ' + err);
			}
		});
	}
}
